__turbopack_context__.v({
  "actions": "cloud-shell-module__N0kGKW__actions",
  "boundary": "cloud-shell-module__N0kGKW__boundary",
  "breadcrumb": "cloud-shell-module__N0kGKW__breadcrumb",
  "callout": "cloud-shell-module__N0kGKW__callout",
  "caseGrid": "cloud-shell-module__N0kGKW__caseGrid",
  "caseSymbol": "cloud-shell-module__N0kGKW__caseSymbol",
  "closing": "cloud-shell-module__N0kGKW__closing",
  "codeBlock": "cloud-shell-module__N0kGKW__codeBlock",
  "container": "cloud-shell-module__N0kGKW__container",
  "copyNotice": "cloud-shell-module__N0kGKW__copyNotice",
  "faq": "cloud-shell-module__N0kGKW__faq",
  "faqSection": "cloud-shell-module__N0kGKW__faqSection",
  "featureRows": "cloud-shell-module__N0kGKW__featureRows",
  "featureSection": "cloud-shell-module__N0kGKW__featureSection",
  "guide": "cloud-shell-module__N0kGKW__guide",
  "guideArticle": "cloud-shell-module__N0kGKW__guideArticle",
  "guideLayout": "cloud-shell-module__N0kGKW__guideLayout",
  "guideMeta": "cloud-shell-module__N0kGKW__guideMeta",
  "guideSection": "cloud-shell-module__N0kGKW__guideSection",
  "guideSidebar": "cloud-shell-module__N0kGKW__guideSidebar",
  "hero": "cloud-shell-module__N0kGKW__hero",
  "heroNote": "cloud-shell-module__N0kGKW__heroNote",
  "inlineHeading": "cloud-shell-module__N0kGKW__inlineHeading",
  "kicker": "cloud-shell-module__N0kGKW__kicker",
  "lead": "cloud-shell-module__N0kGKW__lead",
  "page": "cloud-shell-module__N0kGKW__page",
  "pager": "cloud-shell-module__N0kGKW__pager",
  "previewSection": "cloud-shell-module__N0kGKW__previewSection",
  "primary": "cloud-shell-module__N0kGKW__primary",
  "related": "cloud-shell-module__N0kGKW__related",
  "sectionHeading": "cloud-shell-module__N0kGKW__sectionHeading",
  "sidebarProduct": "cloud-shell-module__N0kGKW__sidebarProduct",
  "srOnly": "cloud-shell-module__N0kGKW__srOnly",
  "terminalCursorStep": "cloud-shell-module__N0kGKW__terminalCursorStep",
  "terminalHeadline": "cloud-shell-module__N0kGKW__terminalHeadline",
  "terminalLetter": "cloud-shell-module__N0kGKW__terminalLetter",
  "terminalLetterReveal": "cloud-shell-module__N0kGKW__terminalLetterReveal",
  "terminalWord": "cloud-shell-module__N0kGKW__terminalWord",
  "textLink": "cloud-shell-module__N0kGKW__textLink",
  "toc": "cloud-shell-module__N0kGKW__toc",
  "useCases": "cloud-shell-module__N0kGKW__useCases",
  "workflow": "cloud-shell-module__N0kGKW__workflow",
});
